import * as React from "react";
import Dialog from "@mui/material/Dialog";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    "& .MuiAvatar-img": {
      objectFit: "contain",
    },
  },
}));

function SimpleDialog(props) {
  const classes = useStyles();
  const { onClose, open } = props;
  return (
    <Dialog className={classes.dialogPaper} onClose={onClose} open={open}>
      {props.data}
    </Dialog>
  );
}

export default function SimpleDialogBox(props) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (value) => {
    setOpen(false);
  };

  return (
    <div>
      <div onClick={handleClickOpen}>{props.button}</div>
      <SimpleDialog data={props.child} open={open} onClose={handleClose} />
    </div>
  );
}
